import { isStandalone, VIEWPORT_MOBILE } from '../styles/media'

export const events = {
	// goals
	SIGN_UP:					'sign_up',
	SUBSCRIBE:					'subscribe',
	INSTALL_PWA:				'install_pwa',
	// events
	SITE_CHANGE_LANGUAGE: 		'Sprache ändern',
	SITE_CHANGE_PRICE_SOURCE: 	'Preisdaten ändern',
	SITE_CHANGE_APPEARANCE: 	'Design ändern',
	SITE_CHANGE_DOMAIN: 		'Domain wechseln',
	SITE_UPDATE:				'Update (neu laden)',
	LOGIN:						'Login',
	LOGOUT:						'Logout',
	ERROR_401:					'401 - Unauthorized',
	ERROR_403:					'403 - Forbidden',
	ERROR_404:					'404 - Not Found',
	ERROR_SERVER:				'Server Error',

	COPY_TO_CLIPBOARD:			'In Zwischenablage kopieren',

	PRICING_SELECT_PLAN:		'Plan auswählen',
	PRICING_YEARLY:				'Jährliche Zahlung',
	CHECKOUT_SELECT_COUNTRY:	'[1] Land ausgewählt',
	CHECKOUT_PAYMENT_METHOD:	'[2] Zahlungsmethode ausgewählt',
	CHECKOUT_ACCEPT_TERMS:		'[3] Zahlungsbedingungen akzeptiert',

	VIEW_IMAGE: 				'Bild ansehen',
	TRANSLATE_CARD:				'Kartentext übersetzen',
	CHANGE_PRINT:				'Print ändern'
}

export const trackEvent = (name, properties = null) => {
	if (window._paq) {
		window._paq.push(['trackEvent', null, name])
	}
}

export const trackSearch = (q, category, resultsCount, generationTime = 0) => {
	if (window._paq) {
		// not available in Matomo 4
		// window._paq.push(['setGenerationTimeMs', generationTime])
		window._paq.push(['trackSiteSearch', q, category, resultsCount])
	}
}

export const trackDownload = (url) => {
	if (window._paq) {
		window._paq.push(['trackLink', url, 'download'])
	}
}

export const trackAppType = (viewport) => {
	if (window._paq) {
		let appType

		if (viewport === VIEWPORT_MOBILE) {
			if (isStandalone()) {
				appType = 'Mobile PWA'
			} else {
				appType = 'Mobile Browser'
			}
		} else if (isStandalone()) {
			appType = 'Desktop PWA'
		} else {
			appType = 'Desktop Browser'
		}

		window._paq.push(['setCustomDimension', 2, appType])
	}
}

export const trackUserType = (authToken, subscribed) => {
	if (window._paq) {
		let visitorType = 'Gast'

		if (authToken) {
			if (subscribed === 'pro') {
				visitorType = 'Pro'
			} else if (subscribed === 'starter') {
				visitorType = 'Starter'
			} else {
				visitorType = 'Benutzer'
			}
		}

		window._paq.push(['setCustomDimension', 1, visitorType])
	}
}

export const formatFieldErrors = fieldErrors => Object.keys(fieldErrors).reduce((accumulator, currentValue) => `${accumulator}${accumulator ? ', ' : ''}${currentValue}`, '')
